import { render } from "./Background.vue?vue&type=template&id=67757167"
import script from "./Background.vue?vue&type=script&lang=js"
export * from "./Background.vue?vue&type=script&lang=js"

import "./Background.vue?vue&type=style&index=0&id=67757167&lang=css"
script.render = render

export default script